import React, { useEffect, useState } from "react";
import { f7, App, View, Page } from "framework7-react";
import routes from "./routes.js";
import axios from "axios";
import { API_BASE_URL, API_AUTH } from "./globals";
const eatBidsLogo = require("./images/logo/eatbids-logo.png");

const f7params = {
  id: "com.restaurant.eatbids", // App bundle ID
  name: "EatBids Restaurant", // App name
  theme: "auto", // Automatic theme detection
  navbar: {
    mdCenterTitle: true,
  },
  externalScripts: [
    "https://themes.pixelstrap.com/zomo-app/assets/js/bootstrap.bundle.min.js",
    "https://themes.pixelstrap.com/zomo-app/assets/js/script.js",
  ],
  routes: routes,
};

const HomePage = () => {
  const id = localStorage.getItem("id");
  const token = localStorage.getItem("token");
  const [auth, setAuth] = useState(localStorage.getItem("auth"));
  const [isLoading, setIsLoading] = useState(true);
  const query = new URLSearchParams(window.location.search);
  const nameParam = query.get("page");

  useEffect(() => {
    if (nameParam) {
      // Use f7 from Framework7React correctly
      const isAlreadyLogged = localStorage.getItem("auth");
      if (nameParam == "signup") {
        if (isAlreadyLogged) {
          setTimeout(() => {
            setIsLoading(false); // API call is complete
            f7.views.main.router.navigate("/main/");
          }, 1000);
        } else {
          setTimeout(() => {
            setIsLoading(false); // API call is complete
            f7.views.main.router.navigate("/register/");
          }, 1000);
        }
      }
      if (nameParam == "signin") {
        if (isAlreadyLogged) {
          setTimeout(() => {
            setIsLoading(false); // API call is complete
            f7.views.main.router.navigate("/main/");
          }, 1000);
        } else {
          setTimeout(() => {
            setIsLoading(false); // API call is complete
            f7.views.main.router.navigate("/login/");
          }, 1000);
        }
      }
    } else {
      const headers = {
        Authorization: "Basic " + API_AUTH,
      };
      axios
        .post(API_BASE_URL + "restauth", { id, token }, { headers })
        .then((response) => {
          console.log(response.data);
          if (response.data.status === "success") {
            localStorage.setItem("auth", true);
            setAuth(true);
            // Introduce a delay of 1000 milliseconds (1 second) after API call success
            setTimeout(() => {
              setIsLoading(false); // API call is complete
              f7.views.main.router.navigate("/main/");
            }, 1000);
          } else {
            localStorage.setItem("auth", false);
            setAuth(false);
            // Introduce a delay of 1000 milliseconds (1 second) after API call failure
            setTimeout(() => {
              setIsLoading(false); // API call is complete
              f7.views.main.router.navigate("/login/");
            }, 1000);
          }
        })
        .catch((error) => {
          // Introduce a delay of 1000 milliseconds (1 second) after API call error
          setTimeout(() => {
            setIsLoading(false); // API call is complete even in case of an error
            console.log(error);
            f7.views.main.router.navigate("/login/");
          }, 1000);
        });
    }
  }, [id, token]);

  if (isLoading) {
    // Render a loading indicator while waiting for the API call to complete
    return (
      <>
        <div>Loading...</div>
        <Page noToolbar noNavbar noSwipeback loginScreen>
          <section className="section-b-space pt-0">
            <div className="container">
              <div className="row">
                <div className="custom-logo">
                  <img
                    className="img-fluid mb-3 mt-3"
                    src={eatBidsLogo}
                    alt="eatBids"
                    style={{ width: "200px" }}
                  />
                </div>
              </div>
            </div>
          </section>
        </Page>
      </>
    );
  }

  return (
    <App {...f7params}>
      {/* Conditional rendering based on auth */}
      <View main url="/main/" />
    </App>
  );
};

export default HomePage;
